import React from 'react';

import flags from '@swf/core/assets/flags';

import ListItem from '../../../../../ListItem/ListItem';

import { avatar, itemText } from './Code.scss';

interface Props {
  code: string;
  text: string;
  value: string;
}

const Code: React.FC<Props> = ({ text, code, value, ...props }) => (
  <ListItem
    primary={text}
    secondary={`+${code}`}
    avatarURL={flags[value]}
    classes={{ itemText, avatar }}
    {...props}
  />
);
export default Code;
